import React, {FC, ReactNode} from 'react';
import {Grid, Theme, useMediaQuery} from "@mui/material";
import {Box} from "@mui/system";

type TypeProps = {
    items: ReactNode[];
}

const List: FC<TypeProps> = ({ items }) => {
    const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

    return (
        <Grid container height={sm ? '100%' : 500}>
            {items.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box p={1}>{item}</Box>
                </Grid>
            ))}
        </Grid>
    );
};

export default List;